import { HttpClient } from '@adapters/HttpClient';

export type CustomerOrigin =
    | 'organic'
    | 'student'
    | 'affiliate'
    | 'meta_ads'
    | 'linkedin_ads'
    | 'google_ads'
    | 'linkedin'
    | 'instagram'
    | 'blog'
    | 'instagram_prospecting'
    | 'linkedin_prospecting'
    | 'cold_email'
    | 'cold_calling'
    | 'referral'
    | 'unknown';

export interface UpdateCommercialRequest {
    commercial_id?: number;
    customer_origin?: CustomerOrigin | null;
}

export class ClientCommercialApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async updateCommercial(teamId: number, data: UpdateCommercialRequest): Promise<void> {
        await this.httpClient.put(`/teams-child/${teamId}/commercial`, data);
    }
}

